export default "__VITE_ASSET__AeZmwf5g__"